import { useEffect } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Avatar, Box, Button, Divider, Drawer, Hidden, List, Typography, Link } from '@material-ui/core';
import {
	// AlertCircle as AlertCircleIcon,
	BarChart as BarChartIcon,
	// Lock as LockIcon,
	Settings as SettingsIcon,
	ShoppingBag as ShoppingBagIcon,
	// User as UserIcon,
	// UserPlus as UserPlusIcon,
	// Users as UsersIcon,
	CreditCard as CreditCardIcon,
	LogOut as LogOutIcon,
	FileText as FileTextIcon,
} from 'react-feather';

import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { logoutAction } from '../store/actions/profile';

import NavItem from './NavItem';
import { getIsVisiblePricing } from '../utils';

// const user = {
// 	avatar: '/static/images/avatars/avatar_6.png',
// 	jobTitle: 'Senior Developer',
// 	name: 'Katarina Smith',
// };

const items = [
	{
		href: '/admin/dashboard',
		icon: BarChartIcon,
		title: 'Dashboard',
	},
	{
		href: '/admin/pricing',
		icon: ShoppingBagIcon,
		title: 'Pricing',
	},
	// {
	// 	href: '/admin/billing',
	// 	icon: CreditCardIcon,
	// 	title: 'Billing',
	// },
	// {
	// 	href: '/admin/settings',
	// 	icon: SettingsIcon,
	// 	title: 'Settings',
	// },
	// {
	// 	href: '/admin/account',
	// 	icon: UserIcon,
	// 	title: 'Account',
	// },
	// {
	// 	href: '/login',
	// 	icon: LockIcon,
	// 	title: 'Login',
	// },
	// {
	// 	href: '/register',
	// 	icon: UserPlusIcon,
	// 	title: 'Register',
	// },
	// {
	// 	href: '/404',
	// 	icon: AlertCircleIcon,
	// 	title: 'Error',
	// },
	// {
	// 	href: '/admin/customers',
	// 	icon: UsersIcon,
	// 	title: 'Customers',
	// },
];

const DashboardSidebar = ({ onMobileClose, openMobile }) => {
	const location = useLocation();
	const dispatch = useDispatch();

	const { profile, subscription } = useSelector((state) => state, shallowEqual);

	useEffect(() => {
		if (openMobile && onMobileClose) {
			onMobileClose();
		}
	}, [location.pathname]);

	const handleLogout = () => {
		dispatch(logoutAction());
	};

	const links = [
		{
			href: '/admin/dashboard',
			icon: BarChartIcon,
			title: 'Dashboard',
		},
		...(getIsVisiblePricing(subscription?.state)
			? [
					{
						href: '/admin/pricing',
						icon: ShoppingBagIcon,
						title: 'Pricing',
					},
			  ]
			: []),
	];

	// const upgradeText = {
	// 	paid: 'Upgrade your plan and access more tracking packages',
	// 	free: 'Upgrade to PRO version and access more tracking packages',
	// 	null: null,
	// }[subscription?.state];

	const content = (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				height: '100%',
			}}
		>
			<Box
				sx={{
					alignItems: 'center',
					display: 'flex',
					flexDirection: 'column',
					p: 2,
				}}
			>
				<Avatar
					component={RouterLink}
					// src={user.avatar}
					sx={{
						cursor: 'pointer',
						width: 64,
						height: 64,
						bgcolor: 'primary.main',
						textDecoration: 'none',
					}}
					to="/dashboard"
				>
					{profile?.email?.[0]?.toUpperCase?.()}
				</Avatar>
				<Typography color="textPrimary" variant="h5" style={{ margin: ' 5px 0 5px 0' }}>
					{profile?.name}
				</Typography>
				{/* <Typography color="textSecondary" variant="body2">
					Trial: Free
				</Typography>
				<Typography color="textSecondary" variant="body2">
					Left: {subscription?.limit}
				</Typography> */}
			</Box>
			<Divider />
			<Box sx={{ p: 2 }}>
				<List>
					{links.map((item) => (
						<NavItem href={item.href} key={item.title} title={item.title} icon={item.icon} />
					))}
					<NavItem
						key={'docs'}
						title={'Docs'}
						icon={FileTextIcon}
						onClick={() => window.open('https://parcelsapp.com/api-docs/')}
					/>
					<NavItem key={'logout'} title={'logout'} icon={LogOutIcon} onClick={handleLogout} blank />
				</List>
			</Box>
			<Box sx={{ flexGrow: 1 }} />
			{/* {upgradeText && (
				<Box
					sx={{
						backgroundColor: 'background.default',
						m: 2,
						p: 2,
					}}
				>
					<Typography align="center" gutterBottom variant="h4">
						Need more?
					</Typography>
					<Typography align="center" variant="body2">
						{upgradeText}
					</Typography>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'center',
							pt: 2,
						}}
					>
						<Link component={RouterLink} to="/admin/pricing" variant="h6">
							<Button color="primary" component="a" variant="contained">
								See plans
							</Button>
						</Link>
					</Box>
				</Box>
			)} */}
		</Box>
	);

	return (
		<>
			<Hidden lgUp>
				<Drawer
					anchor="left"
					onClose={onMobileClose}
					open={openMobile}
					variant="temporary"
					PaperProps={{
						sx: {
							width: 256,
						},
					}}
				>
					{content}
				</Drawer>
			</Hidden>
			<Hidden lgDown>
				<Drawer
					anchor="left"
					open
					variant="persistent"
					PaperProps={{
						sx: {
							width: 256,
							// top: 64,
							height: '100%',
							// height: 'calc(100% - 64px)',
						},
					}}
				>
					{content}
				</Drawer>
			</Hidden>
		</>
	);
};

DashboardSidebar.propTypes = {
	onMobileClose: PropTypes.func,
	openMobile: PropTypes.bool,
};

DashboardSidebar.defaultProps = {
	onMobileClose: () => {},
	openMobile: false,
};

export default DashboardSidebar;
